import React from 'react';
import { Page, Text, BlockStack } from "@shopify/polaris";

import Link from "../../components/Link";
import styles from "./ServerError.module.css";

function ServerError() {
  return (
    <Page>
      <div className={styles.container}>
        <div className={styles.item}>
          <BlockStack gap="200">
            <Text variant="heading3xl" as="p">
              500
            </Text>
            <Text variant="heading2xl" as="p">
              Internal Server Error
            </Text>
            <p>
              Sorry, we had some technical problems during your last operation.
            </p>
            <br />
            <Link url="/">Home</Link>
          </BlockStack>
        </div>
      </div>
    </Page>
  );
};


export default ServerError;
